import { io, Socket } from "socket.io-client";

let socket: Socket | null = null;

export function getSocket(): Socket {
  if (!socket) {
    socket = io(import.meta.env.VITE_SOCKET_URL || "http://localhost:3001", {
      withCredentials: true,
      autoConnect: true,
      // Le proxy edge en prod ne relaie pas l'upgrade WebSocket de Socket.IO
      // (le serveur parle en premier et le frame est bufferisé). Le polling est
      // stable et largement suffisant pour les events du dashboard. Repasser à
      // ["websocket","polling"] si l'upgrade WS est réparé côté nginx-proxy.
      transports: ["polling"],
    });
  }
  return socket;
}
